import React, { Component } from "react";
import { connect } from "dva";
import { downloadImg } from "@/utils/constant";
import http from "@/http";
import UploadList from "@/components/UploadList";
import {
  Checkbox,
  Form,
  Input,
  List,
  message,
  Divider,
  Select,
  Empty,
  Spin,
} from "antd";
import * as DICT from "@/utils/dict";
import styles from "./index.module.less";
import classnames from "classnames";
import { ImageList } from "@/components/Img";
import { DarkModal } from "@/components/Modal";
import darkControl from "@/components/Modal/darkControl.module.less";
import Purview from "@/components/Purview";
import AlarmStatus from "./AlarmStatus";
import AlarmHandleInfo from "./AlarmHandleInfo";
import BaseStatus from "../../overview/device/deviceInfo/components/BaseStatus";
import PushInfo from "../../overview/log/PushLog/PushInfo";
import Scrollbars from "react-custom-scrollbars-2";
import debounce from "lodash.debounce";

const HttpDevice = http.tokiot.device;
const HttpPushMessage = http.tokiot.sys.pushMessage;
const HttpEnterpriseAlarm = http.tokiot.enterprise.alarm;

const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};
const titleStyle = {
  backgroundColor: "rgb(24,144,255)",
  color: "#fff",
  borderBottomRightRadius: "1rem",
  borderTopRightRadius: "1rem",
  fontSize: "0.18rem",
  marginTop: "0.08rem",
  marginBottom: "0.08rem",
  height: "0.3rem",
  width: "1rem",
  textAlign: "center",
};

/**
 * 该组件被fire模块调用
 * 详细路径 routes/fire/components/HandleAlarm
 */
@connect()
class HandleAlarm extends Component {
  state = {
    alarmInfo: {},
    deviceInfo: {},
    alarmList: [],
    pushList: [],
    alaramAllValue: true,
    alarmTotal: 0,
  };

  componentDidMount() {
    const { alarmId } = this.props;
    this.getAlarmList = debounce(this.getAlarmList, 500, {
      leading: true,
      trailing: false,
    });
    if (alarmId) {
      this.getAlarmInfo();
      this.getPushList();
    } else {
      this.getDevice();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { alarmId, form } = this.props;
    if (prevProps.alarmId !== alarmId) {
      form.resetFields();
      if (alarmId) {
        this.getAlarmInfo();
        this.getPushList();
      } else {
        this.getDevice();
      }
    }
  }

  getAlarmInfo = () => {
    const { alarmId } = this.props;
    alarmId &&
      HttpDevice.alarmMongo.get({ id: alarmId }).then((alarmInfo) => {
        if (alarmInfo) {
          if (alarmInfo.state === `UN_HANDLE`) {
            this.getAlarmList(true, alarmInfo.unitId);
          }
          this.setState({ alarmInfo });
        } else {
          this.setState({ alarmInfo: {} });
        }
      });
  };

  getPushList = () => {
    const { alarmId } = this.props;
    alarmId &&
      HttpPushMessage.list({
        bizKey: alarmId,
        bizType: `ALARM`,
        size: 999,
        allUser: true,
      }).then((ret) => {
        if (ret.rows && ret.rows.length > 0) {
          this.setState({ pushList: ret.rows });
        } else this.setState({ pushList: [] });
      });
  };

  getDevice = () => {
    const { deviceId } = this.props;
    deviceId &&
      HttpDevice.get({ id: deviceId }).then((deviceInfo) => {
        deviceInfo && this.setState({ deviceInfo });
        this.getAlarmList(true, deviceInfo.unitId);
      });
  };
  lastParams = {
    size: 20,
    page: 1,
  };
  scrollbars = React.createRef();
  onSrcoll = (event) => {
    const { isEnd, deviceInfo, alarmInfo } = this.state;
    if (this.scrollbars.current) {
      let data = this.scrollbars.current.getValues();
      if (data) {
        if (data && data.top >= 0.99 && !isEnd) {
          let unitId = ``;
          if (deviceInfo) {
            unitId = deviceInfo.unitId;
          }
          if (alarmInfo) {
            unitId = alarmInfo.unitId;
          }
          this.getAlarmList(false, unitId);
        }
      }
    }
  };
  getAlarmList = (isInit, unitId) => {
    const { deviceId, alarmId, form } = this.props;
    const { alarmList, alaramAllValue } = this.state;
    this.setState({ spin: true });
    if (isInit) {
      this.lastParams.page = 1;
    } else {
      this.lastParams.page += 1;
    }

    deviceId &&
      HttpEnterpriseAlarm.list({
        ...this.lastParams,
        deviceId,
        unitId,
        state: `UN_HANDLE`,
      }).then((ret) => {
        if (ret && ret.rows && ret.rows.length > 0) {
          let all = alaramAllValue;
          let rows = [...alarmList, ...ret.rows];
          if (isInit) {
            all = true;
            rows = ret.rows;
          }
          form.setFieldsValue({ deviceAlarmIdList: rows.map((f1) => f1.id) });
          this.setState({
            alarmList: rows,
            all,
            spin: false,
            isEnd: ret.pageNumber >= ret.pageTotal,
            alarmTotal: ret.total,
          });
        } else {
          form.setFieldsValue({ deviceAlarmIdList: [] });
          this.setState({ alarmList: [] });
        }
      });
  };

  handleSelect = (checked) => {
    const { form } = this.props;
    const { alarmList } = this.state;
    if (checked) {
      form.setFieldsValue({
        deviceAlarmIdList: alarmList.map((item) => item.id),
      });
      this.setState({ alaramAllValue: true });
    } else {
      form.setFieldsValue({ deviceAlarmIdList: [] });
      this.setState({ alaramAllValue: false });
    }
  };

  /**
   * 处理上传
   */
  handleUpload(e, type) {
    const { fileList } = e;
    return fileList.map((item) => {
      const { response, status } = item;
      if (status === "done") {
        if (response && response.code === "OK") {
          this.setState({ [type]: response.body });
          return response.body;
        }
      }
    });
  }

  /**
   * 提交表单
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const { form, deviceId, alarmId, onClose, onChange } = this.props;
    const { alaramAllValue } = this.state;
    const { validateFieldsAndScroll } = form;
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.deviceId = deviceId;
        let data = { ...values };
        if (alaramAllValue) {
          delete data.deviceAlarmIdList;
          data.allAlarm = true;
        }
        HttpDevice.handleAlarm(data).then((ret) => {
          if (ret) {
            message.success("处理成功");
            onChange && onChange();
            onClose && onClose();
          } else {
            message.success("处理失败");
          }
        });
      } else {
        return;
      }
    });
  };

  render() {
    const { onClose, form, visible } = this.props;
    const { alarmInfo, alarmList, deviceInfo, pushList } = this.state;
    const { getFieldDecorator } = form;
    const canHandle =
      alarmList.length > 0 ||
      (alarmInfo &&
        alarmInfo.id &&
        alarmInfo.id.length > 0 &&
        alarmInfo.state === `UN_HANDLE`);
    let modalProps = {
      className: darkControl.darkControl,
      title: "警情处理",
      afterClose: () => {
        form.resetFields();
      },
      width: "auto",
      visible,
      maskClosable: false,
      onCancel: onClose,
      onOk: this.handleSubmit,
    };
    if (!canHandle || !Purview({ action: [`DEVICE_HANDLE_ALARM`] })) {
      modalProps.footer = null;
    }
    let showDeviceInfo = deviceInfo;
    if (alarmInfo && alarmInfo.id && alarmInfo.id.length > 0) {
      showDeviceInfo = {
        ...alarmInfo,
        id: alarmInfo.deviceId,
        name: alarmInfo.deviceName,
        sn: alarmInfo.deviceSn,
      };
    }
    return (
      <DarkModal centered {...modalProps}>
        <div className={styles.handleAlarmMain}>
          <div className={styles.left}>
            <div className={styles.row}>
              <Divider orientation={`left`} className={styles.divider}>
                设备信息
              </Divider>
            </div>
            <BaseStatus deviceInfo={showDeviceInfo} showDeviceInfo />
            {pushList && pushList.length > 0 ? (
              <React.Fragment>
                <div className={styles.row}>
                  <Divider orientation={`left`} className={styles.divider}>
                    推送信息
                  </Divider>
                </div>
                <div className={styles.pushList}>
                  {pushList.map((item) => (
                    <PushInfo className={styles.pushInfo} pushInfo={item} />
                  ))}
                </div>
              </React.Fragment>
            ) : (
              ``
            )}
          </div>
          {alarmList && alarmList.length > 0 ? (
            <div className={styles.right}>
              {this.renderAlarmDealWith(alarmList)}
            </div>
          ) : (
            <FormItem className={styles.formItem} colon={false}>
              {getFieldDecorator("deviceAlarmIdList")}
            </FormItem>
          )}
          {canHandle ||
          (alarmInfo && alarmInfo.id && alarmInfo.id.length > 0) ? (
            <div className={styles.alarmInfo}>
              {alarmInfo && alarmInfo.id && alarmInfo.id.length > 0 ? (
                <React.Fragment>
                  <Divider orientation={`left`} className={styles.divider}>
                    告警信息
                  </Divider>
                  <AlarmStatus alarmInfo={alarmInfo} />
                </React.Fragment>
              ) : (
                ``
              )}
              {alarmInfo.state && alarmInfo.state === `HANDLE` ? (
                <React.Fragment>
                  <Divider orientation={`left`} className={styles.divider}>
                    处理结果
                  </Divider>
                  <AlarmHandleInfo alarmInfo={alarmInfo} />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Divider orientation={`left`} className={styles.divider}>
                    告警处理
                  </Divider>
                  {this.renderHandle()}
                </React.Fragment>
              )}
            </div>
          ) : (
            <div className={styles.emptyDiv}>
              <Empty
                className={styles.empty}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={`暂无待处理警情`}
              />
            </div>
          )}
        </div>
      </DarkModal>
    );
  }

  renderHandle = () => {
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <div className={styles.AlarmDealResultDiv}>
        <FormItem {...formItemLayout} label={"处理结果"}>
          {getFieldDecorator("handleMethod", {
            initialValue: DICT.getList("DEVICE_ALARM_HANDLE_METHOD")[0]
              ? DICT.getList("DEVICE_ALARM_HANDLE_METHOD")[0].code
              : "",
            rules: [{ required: true, message: "请选择处理结果" }],
          })(
            <Select
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {DICT.getList("DEVICE_ALARM_HANDLE_METHOD").map((item) => (
                <Option key={item.code} value={item.code}>
                  {item.codeName}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={"处理意见"}>
          {getFieldDecorator("handleRemark", {
            initialValue: "",
          })(<Input placeholder={"请输入处理意见"} />)}
        </FormItem>
        <FormItem {...formItemLayout} label={"现场照片"}>
          {getFieldDecorator("handleImageList", {
            initialValue: "",
          })(<UploadList data={{ type: "OTHER" }} />)}
        </FormItem>
      </div>
    );
  };

  renderAlarmInfo(alarmInfo, weather, params) {
    let showRow = (name, value) => {
      return (
        <div className={styles.row}>
          <div className={styles.left}>{name}</div>
          <div className={styles.right}>{value}</div>
        </div>
      );
    };

    let showParams = () => {
      return (
        <div className={styles.row}>
          <div className={styles.left}>附加说明:</div>
          <div className={styles.right}>
            <div className={styles.body}>
              <div className={styles.left}>
                {params.map((item) => {
                  return <div className={styles.name}>{`${item.name} :`}</div>;
                })}
              </div>
              <div className={styles.right}>
                {params.map((item) => {
                  return <div className={styles.value}>{` ${item.value}`}</div>;
                })}
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className={styles.alarmInfoMain}>
        <div style={{ ...titleStyle, backgroundColor: "rgb(255,77,79)" }}>
          告警信息
        </div>
        <div className={styles.title}></div>
        <div className={styles.body}>
          {showRow(`告警名称:`, alarmInfo.eventName)}
          {showRow(
            `告警级别:`,
            DICT.getValue("EVENT_TYPE", alarmInfo.eventType)
          )}
          {showRow(`发生时间:`, alarmInfo.time)}
          {weather
            ? showRow(
                `实时天气:`,
                `温度:${weather.tem1}℃/${weather.tem2}℃  湿度:${weather.humidity}`
              )
            : ``}
          {params && params.length > 0 ? showParams() : ``}
        </div>
      </div>
    );
  }

  renderDeviceInfo(info) {
    let showRow = (name, value) => {
      return (
        <div className={styles.row}>
          <div className={styles.left}>{name}</div>
          <div className={styles.right}>{value}</div>
        </div>
      );
    };

    return (
      <div className={styles.alarmInfoMain}>
        <div className={styles.title}>
          <div style={titleStyle}>设备信息</div>
        </div>
        <div className={styles.body}>
          {showRow(`设备名称:`, info.deviceName || info.name)}
          {showRow(`设备编号:`, info.deviceSn || info.sn)}
          {showRow(`设备类型:`, info.productName)}
          {showRow(`所属区域:`, info.areaName)}
          {showRow(`所属项目:`, info.unitName)}
          {showRow(`详细地址:`, info.deviceAddress || info.address)}
        </div>
      </div>
    );
  }

  renderHandleInfo(alarmInfo) {
    let showRow = (name, value) => {
      return (
        <div className={styles.row}>
          <div className={styles.left}>{name}</div>
          <div className={styles.right}>{value}</div>
        </div>
      );
    };
    let imageListData = [];
    if (
      alarmInfo &&
      alarmInfo.handleImageList &&
      alarmInfo.handleImageList.length > 0
    ) {
      imageListData = alarmInfo.handleImageList.map((item) => {
        return { src: downloadImg + item };
      });
    }
    let imageList = (
      <ImageList
        imageInfoList={imageListData}
        showImage={(imageList, onImgClick) => {
          if (imageList && imageList.length > 0) {
            let imgList = imageList.map((item, index) => {
              return (
                <div key={index} className={styles.imageInfo}>
                  <img
                    className={styles.image}
                    onClick={() => onImgClick(index)}
                    src={item.src}
                  />
                </div>
              );
            });
            return <div className={styles.imageMainDiv}>{imgList}</div>;
          } else {
            return "";
          }
        }}
      />
    );
    return (
      <div className={styles.alarmInfoMain}>
        <div className={styles.title}>
          <div style={titleStyle}>处理结果</div>
        </div>
        <div className={styles.body}>
          {showRow(`处理人员:`, alarmInfo.handleUser)}
          {showRow(
            `处理结果:`,
            DICT.getValue("DEVICE_ALARM_HANDLE_METHOD", alarmInfo.handleMethod)
          )}
          {showRow(`处理意见:`, alarmInfo.handleRemark)}
          {showRow(`处理时间:`, alarmInfo.handleTime)}
          {showRow(`发生时间:`, alarmInfo.time)}
          {showRow(`现场照片:`, imageList)}
        </div>
      </div>
    );
  }

  renderAlarmDealWith = (alarmList) => {
    const { form, alarmId } = this.props;
    const { alaramAllValue, alarmTotal, spin, isEnd } = this.state;
    const { getFieldDecorator } = form;
    const selected = form.getFieldValue("deviceAlarmIdList") || [];
    return (
      <div className={styles.AlarmDealWithDiv}>
        <div className={styles.title}>
          <Checkbox
            checked={alaramAllValue}
            onClick={(e) => {
              this.handleSelect(e.target.checked);
            }}
          >{`警情列表(${alarmTotal})`}</Checkbox>
        </div>
        <div className={styles.body}>
          <FormItem className={styles.formItem} colon={false}>
            {getFieldDecorator("deviceAlarmIdList", {
              initialValue: [],
              rules: [
                {
                  required: !(alarmId && alarmId.length > 0),
                  message: "请选择警情",
                },
              ],
            })(
              <CheckboxGroup
                className={styles.checkboxGroup}
                onChange={(values) => {
                  this.setState({
                    alaramAllValue: alarmList.length === values.length,
                  });
                }}
              >
                <Spin wrapperClassName={styles.spin} spinning={spin}>
                  <Scrollbars
                    ref={this.scrollbars}
                    onScroll={this.onSrcoll}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                  >
                    <div className={styles.alarm_div}>
                      {alarmList &&
                        alarmList.map((item) => {
                          return (
                            <Checkbox
                              value={item.id}
                              className={styles.checkbox}
                            >
                              <AlarmStatus alarmInfo={item} />
                            </Checkbox>
                          );
                        })}
                      {isEnd ? (
                        <div className={styles.tip}>没有更多数据了</div>
                      ) : (
                        ``
                      )}
                    </div>
                  </Scrollbars>
                </Spin>
              </CheckboxGroup>
            )}
          </FormItem>
        </div>
      </div>
    );
  };
}

export default Form.create()(HandleAlarm);
